import api from './api';

export const locationService = {
  // Get all countries
  getAllCountries: async (params = {}) => {
    const response = await api.get('/locations/countries', { params });
    return response;
  },

  // Get country by ID
  getCountryById: async (countryId) => {
    const response = await api.get(`/locations/countries/${countryId}`);
    return response;
  },

  // Create country
  createCountry: async (data) => {
    const response = await api.post('/locations/countries', data);
    return response;
  },

  // Update country
  updateCountry: async (countryId, data) => {
    const response = await api.put(`/locations/countries/${countryId}`, data);
    return response;
  },

  // Delete country
  deleteCountry: async (countryId) => {
    const response = await api.delete(`/locations/countries/${countryId}`);
    return response;
  },


  // Get all states
  getAllStates: async (params = {}) => {
    const response = await api.get('/locations/states', { params });
    return response; // api interceptor already returns response.data
  },

  // Get state by ID with cities
  getStateById: async (stateId) => {
    const response = await api.get(`/locations/states/${stateId}`);
    return response;
  },

  // Get cities by state
  getCitiesByState: async (stateId) => {
    const response = await api.get(`/locations/states/${stateId}/cities`);
    return response;
  },

  // Get all cities with optional filters
  getAllCities: async (params = {}) => {
    const response = await api.get('/locations/cities', { params });
    return response;
  },

  // Get city by ID
  getCityById: async (cityId) => {
    const response = await api.get(`/locations/cities/${cityId}`);
    return response;
  },

  // Search cities
  searchCities: async (params = {}) => {
    const response = await api.get('/locations/cities/search', { params });
    return response;
  }
};

export default locationService;
